<template>
  <div id="app">
    <div id="nav">
      <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
      <HeaderNav/>
    </div>
    <router-view/>
  </div>
</template>
<script>
import HeaderNav from '@/components/HeaderNav.vue'
export default {
  name:'App',
  components: {
    HeaderNav,
  }
}
</script>
<style lang="scss">
</style>
